import { render, staticRenderFns } from "./VSD.vue?vue&type=template&id=13be1f27&"
import script from "./VSD.vue?vue&type=script&lang=js&"
export * from "./VSD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports